<template>
    <input v-if="column.key" type="text" v-model="value" @input="changed" class="form-control">
</template>
<script>
export default {
    props: ['column'],
    data() {
        return {
            value: '',
        };
    },
    methods: {
        changed() {
            let key = 'q_' + this.column.key;
            if (this.column.translations && this.$lang) {
                key = `${key}->${this.$lang.current}`;
            }
            this.$emit('input', {
                [key]: this.value
            });
        },
    },
    watch: {
        column() {
            this.value = '';
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/table/header/ColumnSearch.vue